import "./AdvSearchPattern.css";

import { useEffect, useLayoutEffect, useState } from "react";

import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

const AdvSearchPattern = ({ selectedPatternOpts, setSelectedSearchOptions }) => {
	const [resOpts, setResOpts] = useState([
		{ id: 1, name: "Материалы", pattern: "__RESOURCE_MAT__", checked: false },
		{ id: 2, name: "Оборудование", pattern: "__RESOURCE_EQP__", checked: false },
		{ id: 3, name: "Перевозка", pattern: "__RESOURCE_PG__", checked: false },
		{ id: 4, name: "Машины и механизмы", pattern: "__RESOURCE_MACH__", checked: false },
	]);
	const [attrOpts, setAttrOpts] = useState([
		{ id: 5, name: "Ресурсы, отсутствующие в ФРСН", pattern: "__RESOURCE_TC__", checked: false },
		{ id: 6, name: "Отрицательные стоимости в позиции", pattern: "__NEGATIVE_COSTS__", checked: false },
	]);

	const dividerFontSize = 13;

	const updateChecked = ({ row, opt }) => {
		if (row.id === opt.id) {
			if (row.checked === true) {
				row.checked = false;
			} else {
				row.checked = true;
			}
		}
		return row;
	};

	useLayoutEffect(() => {
		setResOpts((prev) =>
			prev.map((row) => {
				if (selectedPatternOpts?.find((opt) => opt.checked === true && opt.id === row.id)) row.checked = true;
				return row;
			})
		);
		setAttrOpts((prev) =>
			prev.map((row) => {
				if (selectedPatternOpts?.find((opt) => opt.checked === true && opt.id === row.id)) row.checked = true;
				return row;
			})
		);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const selectObjs = [...resOpts, ...attrOpts];
		const pattern = selectObjs
			.filter((x) => x.checked === true)
			.map((x) => String(x.pattern))
			.join("_");
		setSelectedSearchOptions({ objs: selectObjs, pattern });
	}, [resOpts, attrOpts, setSelectedSearchOptions]);

	return (
		<List sx={{ width: "360px" }}>
			<Divider textAlign="center" style={{ fontSize: dividerFontSize }}>
				Тип ресурса
			</Divider>
			{resOpts.map((opt) => (
				<ListItem
					key={opt.id}
					title={opt.name}
					onClick={() => {
						setResOpts((prev) =>
							prev.map((row) => {
								return updateChecked({ row, opt });
							})
						);
					}}
				>
					<Checkbox checked={opt.checked} />
					<ListItemText primary={opt.name} />
				</ListItem>
			))}
			<Divider textAlign="center" style={{ fontSize: dividerFontSize }}>
				Условия отбора
			</Divider>
			{attrOpts.map((opt) => (
				<ListItem
					key={opt.id}
					title={opt.name}
					onClick={() => {
						setAttrOpts((prev) =>
							prev.map((row) => {
								return updateChecked({ row, opt });
							})
						);
					}}
				>
					<Checkbox checked={opt.checked} />
					<ListItemText primary={opt.name} />
				</ListItem>
			))}
		</List>
	);
};

export default AdvSearchPattern;
